/**
 * Date helpers using Costa Rica time (UTC-6).
 *
 * Why: `new Date().toISOString().split('T')[0]` returns the UTC date. After
 * 18:00 CR, that flips to "tomorrow" and breaks any date defaulting to "today
 * in Costa Rica" (sales report filters, daily sales fetches, etc.).
 *
 * These helpers always return calendar dates as seen from Costa Rica.
 */

// Locale formatter that yields YYYY-MM-DD components in CR time. We use the
// Swedish locale because it natively returns the ISO-style YYYY-MM-DD.
const CR_DATE_FMT = new Intl.DateTimeFormat("sv-SE", {
  timeZone: "America/Costa_Rica",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** Today as YYYY-MM-DD in Costa Rica time. */
export function todayCR(date = new Date()) {
  return CR_DATE_FMT.format(date);
}

/** Add `days` to a YYYY-MM-DD string and return YYYY-MM-DD.  Pure math, no TZ. */
export function addDays(isoDate, days) {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}
